<ui-card role="group" [attr.aria-label]="'time-off-v3.policyComponents.accrualCard.accrualSettings' | translate">
    <div class="margin-bottom-4">
        <app-segment-header [title]="'time-off-v3.policyComponents.accrualCard.accrualSettings'">
            <div class="buttons">
                <ui-button *ngIf="editMode" type="link" url="../accrual"> {{ 'edit' | translate }} </ui-button>
            </div>
        </app-segment-header>

        <div role="list">
            <div class="field-container" role="listitem" aria-labelledby="need-accrual-schedule">
                <span id="need-accrual-schedule" class="label">{{
                    'time-off-v3.policyComponents.accrualCard.needAccrualSchedule' | translate
                }}</span>
                <div class="value">
                    <div *ngIf="timeOffPolicy.isUnlimited">
                        <div>
                            {{ 'time-off-v3.policyComponents.accrualSettings.thisPolicyIsUnlimited' | translate }}
                        </div>
                        <div class="subscript">
                            {{ 'time-off-v3.policyComponents.accrualSettings.assignedHelperText' | translate }}
                        </div>
                    </div>

                    <div *ngIf="!timeOffPolicy.isUnlimited">
                        {{ 'time-off-v3.policyComponents.accrualCard.yes' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!timeOffPolicy.isUnlimited">
        <div class="margin-bottom-4">
            <app-segment-header
                [title]="'time-off-v3.policyComponents.accrualCard.amountAccruedHeader'"
            ></app-segment-header>

            <div role="list">
                <div class="field-container" role="listitem" aria-labelledby="basic-accrual">
                    <span id="basic-accrual" class="label">{{
                        'time-off-v3.policyComponents.accrualCard.basicAccrual' | translate
                    }}</span>
                    <div class="value">{{ days | i18nNum }} {{ this.unitOfTimeHeader | translate }}</div>
                </div>

                <div class="field-container margin-top-3">
                    <span class="label">{{
                        'time-off-v3.policyComponents.accrualCard.seniorityIncrease' | translate
                    }}</span>
                    <div class="value">
                        <ng-container *ngFor="let seniorityOverride of timeOffSeniorityOverrides; let i = index">
                            <div>
                                {{
                                    'time-off-v3.policyComponents.accrualCard.afterNumberYears'
                                        | translate
                                            : {
                                                  numberOfYears: seniorityOverride.afterNumberOfYears | i18nNum,
                                                  accruePeriod:
                                                      getAccruesPerPeriod(seniorityOverride, timeOffPolicy)
                                                      | i18nNum: 'no$',
                                                  unit: unitOfTime | translate | lowercase,
                                              }
                                }}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="margin-bottom-4">
            <app-segment-header
                [title]="'time-off-v3.policyComponents.accrualCard.accrualScheduleHeader'"
            ></app-segment-header>

            <div role="list">
                <div class="field-container margin-top-3" role="listitem" aria-labelledby="accrual-frequency">
                    <span id="accrual-frequency" class="label">{{
                        'time-off-v3.policyComponents.accrualCard.accrualFrequency' | translate
                    }}</span>
                    <div class="value" translate="time-off-v3.{{ timeOffPolicy.accrualFrequency }}"></div>
                </div>

                <div
                    class="field-container margin-top-3"
                    role="listitem"
                    aria-labelledby="accrual-happens-on"
                    *ngIf="timeOffPolicy.accrualTiming"
                >
                    <span id="accrual-happens-on" class="label">{{
                        'time-off-v3.policyComponents.accrualCard.accrualHappensOn' | translate
                    }}</span>
                    <div class="value">
                        {{
                            AccrualTimingDisplayOptions[timeOffPolicy.accrualTiming] ?? timeOffPolicy.accrualTiming
                                | translate
                        }}
                    </div>
                </div>

                <div
                    class="field-container margin-top-3"
                    role="listitem"
                    aria-labelledby="first-day-of-accrual-period"
                    *ngIf="firstDayOfPeriod"
                >
                    <span id="first-day-of-accrual-period" class="label">{{
                        'time-off-v3.policyComponents.accrualCard.firstDayOfAccrualPeriod' | translate
                    }}</span>
                    <div class="value">{{ firstDayOfPeriod }}</div>
                </div>

                <ng-container *ngIf="timeOffPolicy.accrualFrequency === 'bi-weekly'">
                    <div class="field-container margin-top-3" role="listitem" aria-labelledby="which-week-value">
                        <span id="which-week-value" class="label">{{
                            'time-off-v3.whichWeekValue' | translate: { week: firstDayOfPeriod }
                        }}</span>
                        <div class="value">{{ biWeeklyAnchorDates }}</div>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="
                        timeOffPolicy.accrualFrequency === 'quarterly' ||
                        (timeOffPolicy.accrualFrequency === 'annually' && !this.timeOffPolicy.accrualFromHireDate)
                    "
                >
                    <div class="field-container margin-top-3" role="listitem" aria-labelledby="which-day-of-month">
                        <span id="which-day-of-month" class="label">{{
                            'time-off-v3.whichDayOfMonth' | translate
                        }}</span>
                        <div class="value">{{ dayOfTheMonth }}</div>
                    </div>
                </ng-container>

                <div
                    class="field-container margin-top-3"
                    role="listitem"
                    aria-labelledby="prorate-first-accrual-amount"
                >
                    <span id="prorate-first-accrual-amount" class="label">{{
                        'time-off-v3.policyComponents.accrualCard.prorateFirstAccrualAmount' | translate
                    }}</span>
                    <div class="value">
                        {{
                            (timeOffPolicy.proratesFirstAccrual
                                ? 'time-off-v3.policyComponents.accrualCard.yes'
                                : 'time-off-v3.policyComponents.accrualCard.no'
                            ) | translate
                        }}
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="accrualPreviews.length > 0" class="margin-bottom-3">
            <h2>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualSchedulePreviewHeader' | translate }}</h2>
            <table class="columns-10 preview-table">
                <thead>
                    <tr>
                        <th>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualHappenOnColumn' | translate }}</th>
                        <th>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualPeriodColumn' | translate }}</th>
                        <th>{{ 'time-off-v3.policyComponents.accrualSchedule.accrualAmountColumn' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let accrualPreview of accrualPreviews">
                        <td>
                            {{
                                getAccrualHappenOnDate(
                                    accrualPreview.attributes.startDate,
                                    accrualPreview.attributes.endDate
                                ) | i18nDate: 'longWeekday'
                            }}
                        </td>
                        <td>
                            {{ accrualPreview.attributes.startDate | i18nDate: 'short' }} -
                            {{ accrualPreview.attributes.endDate | i18nDate: 'short' }}
                        </td>

                        <td>{{ daysPerPeriod | i18nNum }} {{ unitOfTime | translate | lowercase }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="margin-top-2">
            <app-segment-header [title]="'time-off-v3.policyComponents.carryOverCard.header'"></app-segment-header>

            <div role="list">
                <div class="field-container" role="listitem" aria-labelledby="carryover-method">
                    <span id="carryover-method" class="label">{{
                        'time-off-v3.policyComponents.carryOverCard.carryoverMethod' | translate
                    }}</span>
                    <div class="value">{{ carryoverMethod | translate }}</div>
                </div>

                <div
                    class="field-container"
                    role="listitem"
                    aria-labelledby="balance-reset-date"
                    *ngIf="timeOffPolicy.isAnnualReset()"
                >
                    <span id="balance-reset-date" class="label">{{
                        'time-off-v3.policyComponents.carryOverCard.balanceResetDate' | translate
                    }}</span>
                    <div class="value" *ngIf="capOnDateVal === capOnOptions.dateHired">
                        {{
                            'time-off-v3.policyComponents.carryover.employeesHireDateAnniversary'
                                | translate
                                | capitalize
                        }}
                    </div>
                    <div class="value" *ngIf="capOnDateVal === capOnOptions.yearEnd">
                        {{ 'time-off-v3.policyComponents.carryover.theEndOfTheYearCapital' | translate }}
                    </div>
                    <div class="value" *ngIf="capOnDateVal === capOnOptions.pickDate">
                        {{ timeOffPolicy.carryoverDate | i18nDate: 'long' }}
                    </div>
                </div>

                <ng-container *ngIf="maxCarryoverDate">
                    <div
                        class="field-container margin-top-3"
                        role="listitem"
                        aria-labelledby="maximum-carryover-amount"
                    >
                        <span id="maximum-carryover-amount" class="label">{{
                            'time-off-v3.policyComponents.carryOverCard.maximumCarryoverAmount' | translate
                        }}</span>
                        <div class="value">
                            {{
                                maxCarryoverDate
                                    | translate
                                        : {
                                              carryoverCap: timeOffPolicy.carryoverCap | i18nNum,
                                              unitOfTimePlural:
                                                  timeOffPolicy.timeOffType.unitOfTimePluralTranslation | translate,
                                              carryoverDate: timeOffPolicy.carryoverDate | i18nDate: 'shortNoYear',
                                          }
                            }}
                        </div>
                    </div>

                    <div
                        class="field-container margin-top-3"
                        role="listitem"
                        aria-labelledby="carryover-amount-expires-after"
                    >
                        <span id="carryover-amount-expires-after" class="label">{{
                            'time-off-v3.policyComponents.carryOverCard.carryoverAmountExpiresAfter' | translate
                        }}</span>
                        <div class="value">
                            <span *ngIf="timeOffPolicy.carryoverExpireAfter">
                                {{ timeOffPolicy.carryoverExpireAfter | i18nNum }}
                                {{ 'time-off-v3.days' | translate | lowercase }}
                            </span>

                            <span *ngIf="!timeOffPolicy.carryoverExpireAfter">
                                {{ 'time-off-v3.policyComponents.carryOverCard.noCarryoverExpiration' | translate }}
                            </span>
                        </div>
                    </div>
                </ng-container>

                <div class="field-container margin-top-3" role="listitem" aria-labelledby="maximum-balance">
                    <span id="maximum-balance" class="label">{{
                        'time-off-v3.policyComponents.carryOverCard.maximumBalance' | translate
                    }}</span>
                    <div class="value" *ngIf="timeOffPolicy.balanceCap">
                        {{ timeOffPolicy.balanceCap | i18nNum }}
                        {{ timeOffPolicy.timeOffType.unitOfTimePluralTranslation | translate | titlecase }}
                    </div>

                    <div class="value" *ngIf="!timeOffPolicy.balanceCap">
                        {{ 'time-off-v3.policyComponents.carryOverCard.unlimited' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ui-card>
